import { Skeleton, Stack, Tabs, Title } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'
import { useAlbums, useArtists, useTracks } from '~/api/queries'
import { AlbumGrid } from '~/components/blocks/AlbumGrid/AlbumGrid'
import { ArtistGrid } from '~/components/blocks/ArtistGrid/ArtistGrid'
import { TrackTable } from '~/components/blocks/TrackTable/TrackTable'

export const Route = createFileRoute('/_app/favorites/')({
  component: FavoritesPage,
})

function FavoritesPage() {
  const { data: artists, isLoading: loadingArtists } = useArtists({
    favorited: 'true',
    limit: 100,
  })
  const { data: albums, isLoading: loadingAlbums } = useAlbums({
    favorited: 'true',
    limit: 100,
  })
  const { data: tracks, isLoading: loadingTracks } = useTracks({
    favorited: 'true',
    limit: 100,
  })

  return (
    <Stack gap="md">
      <Title order={2}>Favorites</Title>

      <Tabs defaultValue="tracks">
        <Tabs.List>
          <Tabs.Tab value="tracks">Tracks ({tracks?.total ?? 0})</Tabs.Tab>
          <Tabs.Tab value="albums">Albums ({albums?.total ?? 0})</Tabs.Tab>
          <Tabs.Tab value="artists">Artists ({artists?.total ?? 0})</Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="tracks" pt="md">
          {loadingTracks ? (
            <Skeleton h={300} />
          ) : tracks?.data ? (
            <TrackTable tracks={tracks.data} />
          ) : null}
        </Tabs.Panel>

        <Tabs.Panel value="albums" pt="md">
          {loadingAlbums ? (
            <Skeleton h={300} />
          ) : albums?.data ? (
            <AlbumGrid albums={albums.data} />
          ) : null}
        </Tabs.Panel>

        <Tabs.Panel value="artists" pt="md">
          {loadingArtists ? (
            <Skeleton h={300} />
          ) : artists?.data ? (
            <ArtistGrid artists={artists.data} />
          ) : null}
        </Tabs.Panel>
      </Tabs>
    </Stack>
  )
}
